<template>
  <section id="chatMessages" class="chat-wrapper" @mousedown="setFocusMessage">
    <div class="chat-messages-wrapper">
      <!-- Overlay (for notices, reporting) -->
      <div class="chat-messages-overlay" :style="{ display: showOverlay }">
        <div class="chat-messages-overlay-centered">
          <!-- Overlay Header -->
          <div class="chat-messages-overlay-header">
            <span>{{ overlayTitle }}</span>
            <div title="close" class="chat-messages-overlay-action" @click="closeOverlay">
              <i class="fas fa-times"></i>
            </div>
          </div>
          <!-- Overlay Content -->
          <div v-if="isReport" class="chat-messages-overlay-content">
            <div class="row mt-4">
              <div class="col">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Report</span>
                  </div>
                  <select v-model="selectedReport" class="form-control">
                    <option v-for="item of reportCategory" :key="item.value" :value="item.value">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <dt-textarea v-model="reportComments" label="Comments" />
              </div>
            </div>
          </div>
          <div v-if="isConfirm" class="chat-messages-overlay-content">
            <p>Are you sure you want to remove this Chat Session?</p>
          </div>
          <!-- Overlay Footer -->
          <div v-if="isReport" class="chat-messages-overlay-footer">
            <button class="btn btn-primary btn-sm" @click="saveReport">Save</button>
            <button class="btn btn-primary btn-sm ms-1" @click="closeOverlay">Cancel</button>
          </div>
          <div v-if="isConfirm" class="chat-messages-overlay-footer">
            <button class="btn btn-primary btn-sm" @click="removeChannel">Remove</button>
            <button class="btn btn-primary btn-sm ms-1" @click="closeOverlay">Cancel</button>
          </div>
        </div>
      </div>
      <!-- Chat Session & Message Header -->
      <div id="chatMessagesheader" class="chat-messages-header" @click="closeEmoji">
        <div class="row chat-messages-header-row">
          <div class="col-1">
            <!-- members -->
            <div class="chat-messages-members" title="channel members">
              <!-- <i class="fas fa-users"></i> -->
              <b-button :id="`members_${channelId}`" class="custom-popover" variant="link" @click="showMembers"
                ><i class="fas fa-users"></i
              ></b-button>
              <b-popover :target="`members_${channelId}`" triggers="hover focus" placement="left">
                <template #title
                  >Session Members</template
                >
                <ul class="custom-list">
                  <li v-for="item of members" :key="item.id">{{ item.name }}</li>
                </ul>
              </b-popover>
            </div>
          </div>
          <div class="col">
            <!-- title -->
            <div class="chat-messages-title">{{ title }}</div>
          </div>
          <div class="col-3">
            <!-- actions -->
            <div class="chat-messages-actions">
              <div title="drop to chat bar" class="chat-message-action" @click="minimizeMessages">
                <i class="fas fa-chevron-down"></i>
              </div>
              <!-- <div title="manage session" class="chat-message-action" @click="showManage">
                <i class="fas fa-cog"></i>
              </div> -->
              <div title="close" class="chat-message-action" @click="closeMessages">
                <i class="fas fa-times"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="row chat-messages-header-row">
          <div class="col-1 text-center">
            <div v-if="isTrash" class="chat-trash" title="remove chat session" @mousedown.prevent="confirmRemoveChannel">
              <i class="fas fa-trash"></i>
            </div>
          </div>
          <div class="col chat-messages-title-footer">
            <div class="chat-messages-subtitle">{{ subtitle }}</div>
            <div class="chat-messages-foot-title">{{ footertitle }}</div>
          </div>
        </div>
      </div>
      <!-- Message Listing -->
      <div class="chat-messages-content" @click="closeEmoji">
        <!-- messages -->
        <div class="row md messages-content">
          <div v-if="isLoading" class="col"></div>
          <div v-else ref="chatMessages" class="col messages">
            <div
              v-for="(item, idx) in messages"
              :key="idx"
              class="message"
              :class="setMessageClass(item, idx)"
              @contextmenu.prevent="event => showContextMenu(event, item)"
            >
              <div class="message-content">
                <div class="message-name">{{ item.name }}</div>
                <div class="message-bubble" :style="`backgroundColor: ${item.color};`">
                  <div class="message-text">
                    <span v-html="item.message" :class="setMessageTextClass(item, idx)"></span>
                  </div>
                  <div class="message-text-footer chat-messages-message-footer">
                    {{ item.createdOn }}
                  </div>
                  <div v-if="isMemberName(item, idx)" class="message-text-footer chat-messages-message-footer">
                    {{ item.member }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- popup menu -->
          <div v-show="contextMenuVisible" class="chat-messages-menu" :style="{ left: contextMenuX + 'px', top: contextMenuY + 'px' }">
            <div class="dropdown-menu" style="display:block;">
              <a class="dropdown-item chat-messages-menu-link" @mousedown="showReportMessage">Report</a>
            </div>
          </div>
        </div>
      </div>
      <div ref="msgFooter" class="chat-messages-footer" :style="{ height: footerHeight + 'px' }">
        <!-- Who's Typing -->
        <div class="row">
          <div class="col chat-messages-typing">
            <span>{{ whosTyping }}</span>
          </div>
        </div>
        <!-- message bar (type new message and emojis) -->
        <div v-if="!isAdmin" class="row chat-messages-footer-row">
          <div class="col chat-messages-message-area">
            <textarea
              v-model="newMessage"
              ref="newMessage"
              placeholder="type message..."
              class="chat-messages-message"
              @keyup="userTyping"
              @mousedown="resizeMsg(1)"
              @mousemove="resizeMsg(2)"
              @mouseup="resizeMsg(3)"
              @focus="resizeMsg(4)"
            ></textarea>
            <div class="chat-emoji" @click="toggleEmoji">
              <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                />
              </svg>
            </div>
            <div class="chat-messages-message-paperclip">
              <a @click="toggleFileUpload">
                <i class="fas fa-paperclip"></i>
              </a>
            </div>
          </div>
          <div class="col-1 chat-message-send">
            <!-- send a message -->
            <a href="#" title="send message" @click="processMessage">
              <i class="fas fa-share-square"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- emoji widget -->
    <emoji-widget ref="emojiWidget" @emoji="appendEmoji" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EmojiWidget from '@/components/chat/elements/emoji/emoji-widget.vue'
import globals from '@/plugins/globals'
import DtTextarea from '@/components/utilities/form/dt-textarea'
export default {
  name: 'chat-messages',
  components: {
    EmojiWidget,
    DtTextarea
  },
  props: {
    channelUrl: String,
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      placeholder: 'type message...',
      newMessage: '',
      search: '',
      waitTimeout: null,
      waitTypingTimeout: null,
      isShowMembers: false,
      isTyping: false,
      isConfirm: false,
      isLoading: false,
      isMouseDown: false,
      footerHeight: 100,
      contextMenuVisible: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextMessage: null,
      overlayTitle: null,
      showOverlay: 'none',
      isReport: false,
      selectedReport: null,
      reportComments: null,
      reportCategory: [
        {
          name: 'Suspicious',
          value: 'suspicious'
        },
        {
          name: 'Harassing',
          value: 'harassing'
        },
        {
          name: 'Inappropriate',
          value: 'inappropriate'
        },
        {
          name: 'Spam',
          value: 'spam'
        }
      ]
    }
  },
  mounted() {
    this.isShowMembers = false
    this.isMouseDown = false
    this.showOverlay = 'none'
    this.isReport = false
    this.isConfirm = false
    this.selectedReport = null
    this.reportComments = null
    globals.dragElement(document.getElementById('chatMessages'))
    this.setFocusMessage()
  },
  watch: {
    changed(data) {
      console.log('Chat Messages - change triggered', data)
      this.showLastMessage()
    },
    messages() {
      this.showLastMessage()
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('chat', ['channelInfo', 'messages', 'changed', 'someoneTyping']),
    isShop() {
      let _is = false
      if (this.profile) {
        if ([15, 16, 17].includes(this.profile.roles[0])) {
          _is = true
        }
      }
      return _is
    },
    title() {
      let _title = 'Chat'
      if (this.channelInfo) {
        if (this.channelInfo.type === 'adhoc') {
          _title = this.channelInfo.name
        } else {
          if (this.channelInfo.metadata) {
            if (Object.keys(this.channelInfo.metadata).length) {
              _title = `# ${this.channelInfo.name} - RO ${this.channelInfo.metadata.ronumber}`
            } else {
              _title = `${this.channelInfo.name}`
            }
          } else {
            _title = `${this.channelInfo.name}`
          }
        }
      }
      return _title
    },
    subtitle() {
      let _subtitle = ''
      if (this.channelInfo) {
        if (this.channelInfo.metadata) {
          if (Object.keys(this.channelInfo.metadata).length) {
            _subtitle = `${this.channelInfo.metadata.year} ${this.channelInfo.metadata.make} ${this.channelInfo.metadata.model}`
          }
        }
      }
      return _subtitle
    },
    footertitle() {
      let _footer = ''
      if (this.channelInfo && !this.isShop) {
        if (this.channelInfo.metadata) {
          if (Object.keys(this.channelInfo.metadata).length) {
            _footer = this.channelInfo.metadata.firmName
          }
        }
      }
      return _footer
    },
    channelId() {
      let _id = ''
      if (this.channelInfo) {
        _id = this.channelInfo.url
      }
      return _id
    },
    members() {
      let _data = null
      if (this.channelInfo) {
        _data = this.channelInfo.members
      }
      return _data
    },
    channelType() {
      let _type = null
      if (this.channelInfo) {
        _type = this.channelInfo.type
      }
      return _type
    },
    owner() {
      let _owner = null
      if (this.channelInfo) {
        _owner = this.channelInfo.owner
      }
      return _owner
    },
    isTrash() {
      let _is = false
      if (this.channelInfo) {
        if (this.channelInfo.type.substring(0, 5) === 'adhoc' && this.channelInfo.owner !== null) {
          if (this.channelInfo.owner === this.profile.guid) {
            _is = true
          }
        }
      }
      return _is
    },
    whosTyping() {
      let _who = ''
      if (this.someoneTyping) {
        if (this.channelInfo && this.channelInfo.url === this.someoneTyping.url) {
          this.someoneTyping.members.forEach(member => {
            if (_who !== '') {
              _who += ', '
            }
            _who += member.nickname
          })
          _who += ' is typing'
        }
      }
      return _who
    }
  },
  methods: {
    ...mapActions('chat', ['sendMessage', 'memberTyping', 'setSubcribeToChannel', 'getChannelMessages', 'deleteChannel', 'reportMessage']),
    toggleEmoji() {
      this.$refs.emojiWidget.toggle()
    },
    toggleFileUpload() {
      this.$emit('upload')
    },
    closeEmoji() {
      this.$refs.emojiWidget.hide()
      this.closeOverlay()
    },
    appendEmoji(emoji) {
      this.newMessage += emoji
    },
    setFocusMessage() {
      if (this.$refs.newMessage) {
        this.$refs.newMessage.focus()
      }
    },
    showContextMenu(event, item) {
      if (item) {
        this.contextMessage = item
        this.contextMenuX = event.pageX
        this.contextMenuY = event.pageY
        this.contextMenuVisible = true
      }
    },
    hideContextMenu() {
      this.contextMenuVisible = false
    },
    closeOverlay() {
      this.isReport = false
      this.isConfirm = false
      this.contextMessage = null
      this.contextMenuVisible = false
      this.overlayTitle = null
      this.selectedReport = null
      this.reportComments = null
      this.showOverlay = 'none'
    },
    showReportMessage() {
      this.isReport = true
      this.isConfirm = false
      this.overlayTitle = 'Report Message'
      this.showOverlay = 'flex'
      this.hideContextMenu()
    },
    async saveReport() {
      let data = {
        channelUrl: this.channelInfo.url,
        messageId: this.contextMessage.id.toString(),
        reportCategory: this.selectedReport,
        offendingUserId: this.contextMessage.guid,
        reportingUserId: this.profile.guid,
        reportDescription: this.reportComments
      }
      await this.reportMessage(data)
      this.closeOverlay()
    },
    resizeMsg(action) {
      switch (action) {
        case 1:
          this.isMouseDown = true
          break
        case 2:
          if (this.isMouseDown && this.$refs.newMessage.offsetHeight + 10 > 60 && this.$refs.newMessage.offsetHeight + 10 < 250) {
            this.footerHeight = this.$refs.newMessage.offsetHeight + 10
          } else if (this.isMouseDown) {
            this.$refs.newMessage.style.height = this.$refs.msgFooter.style.height
          }
          break
        case 3:
          this.isMouseDown = false
          break
        case 4:
          this.isMouseDown = false
          this.$refs.newMessage.style.height = this.$refs.msgFooter.style.height
          break
      }
    },
    setMessageClass(msg, idx) {
      let previousMessage = this.messages[idx - 1]
      let nextMessage = this.messages[idx + 1]
      let _class = ''
      if (msg.type === 'sent') {
        _class = 'message-sent'
      } else {
        _class = 'message-received'
      }
      if (!previousMessage || previousMessage.type !== msg.type || previousMessage.name !== msg.name) {
        _class += ' message-first'
      }
      if (!nextMessage || nextMessage.type !== msg.type || nextMessage.member !== msg.member) {
        _class += ' message-last message-tail'
      }
      return _class
    },
    setMessageTextClass(msg, idx) {
      let _class = ''
      if (msg.type === 'sent') {
        _class = 'message-text-sent'
      }
      return _class
    },
    isMemberName(msg, idx) {
      let is = false
      let nextMessage = this.messages[idx + 1]
      if (!nextMessage || nextMessage.type !== msg.type || nextMessage.member !== msg.member) {
        is = true
      }
      return is
    },
    showLastMessage() {
      let $this = this
      setTimeout(function() {
        var elements = $this.$el.getElementsByClassName('message')
        if (elements.length) {
          elements[elements.length - 1].scrollIntoView()
        }
      }, 500)
    },
    async refreshMessages() {
      await this.getChannelMessages(this.channelInfo)
    },
    showManage() {
      this.$emit('showManage')
    },
    async createUploadMessage(data) {
      let msg = `uploaded: <a href="${data.url}">${data.filename}</a>`
      await this.sendMessage(msg)
      this.$refs.newMessage.focus()
      this.$emit('upload')
    },
    async processMessage() {
      console.log('Process Message', this.channelInfo)
      if (this.channelInfo) {
        this.sendMessage(this.newMessage)
      }
      this.closeEmoji()
      this.$refs.newMessage.focus()
      this.newMessage = ''
    },
    showMembers() {
      this.isShowMembers = !this.isShowMembers
      this.$emit('showMembers', this.isShowMembers)
    },
    confirmRemoveChannel() {
      this.overlayTitle = 'Confirm Removal'
      this.showOverlay = 'flex'
      this.isReport = false
      this.isConfirm = true
    },
    async removeChannel() {
      this.showOverlay = 'none'
      this.isConfirm = false
      if (this.isTrash) {
        await this.deleteChannel(this.channelInfo.url)
        this.$emit('trashed')
      }
    },
    editMembers() {
      this.isShowMembers = false
      this.$emit('editMembers')
    },
    closeMessages() {
      this.$emit('closeMessages')
    },
    minimizeMessages() {
      this.$emit('minimizeMessages')
    },
    userTyping(e) {
      let $this = this
      window.clearTimeout(this.waitTimeout)
      window.clearTimeout(this.waitTypingTimeout)
      let data = {
        url: this.channelInfo.url,
        status: 'typing_on'
      }
      this.waitTypingTimeout = window.setTimeout(() => {
        $this.memberTyping(data)
      }, 250)
      this.waitTimeout = window.setTimeout(() => {
        data.status = 'typing_off'
        $this.memberTyping(data)
      }, 1500)
      if (e.keyCode === 13) {
        if (e.ctrlKey) {
          this.message += '\n'
        } else {
          e.preventDefault()
          this.processMessage()
        }
      }
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  }
}
</script>
<style scoped>
.popover {
  z-index: 99999;
}
.custom-popover {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/elements/chat-messages.vue